import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { PUT, newFetch } from '../../../../../helpers/fetch';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../../components/SweetAlert';

const ChangePassword = ({ history }) => {
  const type = localStorage.getItem('type');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  const discardPasswordHandler = () => {
    setOldPassword('');
    setNewPassword('');
    setConfirmNewPassword('');
  };

  const submitPasswordHandler = async (e) => {
    e.preventDefault();

    if (!oldPassword) {
      ToastUtil.error('Please input Old Password!');
      return false;
    }

    if (!newPassword) {
      ToastUtil.error('Please input New Password!');
      return false;
    }

    if (!confirmNewPassword) {
      ToastUtil.error('Please input Confirm New Password!');
      return false;
    }

    if (newPassword !== confirmNewPassword) {
      ToastUtil.error('Password did not match!');
      return false;
    }

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to update your password?'
      )
    ) {
      var api_path = '';

      type === 'client'
        ? (api_path = '/client/change-password')
        : (api_path = '/admin/change-password');

      let data = {
        old_password: oldPassword,
        new_password: newPassword,
      };
      let response = await newFetch(PUT, api_path, data);

      ToastUtil.error(
        `${response.message}.` +
          (response.success
            ? ` Please login again to continue using the system.`
            : '')
      );
      response.success && history.push('/logout');
    }
  };

  return (
    <form
      onSubmit={(e) => submitPasswordHandler(e)}
      className="d-flex flex-column"
    >
      <div className="p-4 d-flex flex-column">
        <h5 className="mb-4 pb-2">Change Password</h5>
        <div className="mb-2">
          <label htmlFor="oldPassword" className="fw-semibold mb-2">
            Old Password
          </label>
          <input
            type="password"
            className="form-control adjust-fs"
            id="oldPassword"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
          />
        </div>
        <div className="mb-2">
          <label htmlFor="newPassword" className="fw-semibold mb-2">
            New Password
          </label>
          <input
            type="password"
            className="form-control adjust-fs"
            id="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>
        <div className="mb-2">
          <label htmlFor="confirmNewPassword" className="fw-semibold mb-2">
            Confirm New Password
          </label>
          <input
            type="password"
            className="form-control adjust-fs"
            id="confirmNewPassword"
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
          />
        </div>
      </div>
      <div
        style={{
          height: '4.5rem',
        }}
        className="border-top bg-white d-flex align-items-center justify-content-end mt-auto p-4"
      >
        <button
          type="button"
          onClick={discardPasswordHandler}
          className="btn btn-outline-brand adjust-fs adjust-shadow"
          style={{ width: '12rem' }}
        >
          Discard
        </button>
        <button
          type="submit"
          className="btn btn-brand ms-3 adjust-fs adjust-shadow"
          style={{ width: '12rem' }}
        >
          Save changes
        </button>
      </div>
    </form>
  );
};

export default withRouter(ChangePassword);
